import React, { ChangeEvent, useEffect, useRef } from 'react';
import { ToggleType } from '../../../Data/Enums/Generic';
import ValidationError from '../ValidationError';
import FormEntryWrapper from '../FormEntryWrapper/FormEntryWrapper';
import { ToggleSwitchType } from './ToggleSwitchTypes';

const ToggleSwitch = (props: ToggleSwitchType) => {
	if (props.inForm) {
		return (
			<FormEntryWrapper invalid={props.invalid}>
				<div />
				<RenderToggle {...props} />
			</FormEntryWrapper>
		);
	}

	return <RenderToggle {...props} />;
};

export default ToggleSwitch;

const RenderToggle = (props: ToggleSwitchType) => {
	const toggleId = `${props.name.toLowerCase().replace(/ /g, '')}${props.label.toLowerCase().replace(/ /g, '')}`;
	const toggleRef = useRef<HTMLInputElement>(null);

	const HandleCallBack = (e: React.ChangeEvent) => {
		if (props.onChange) {
			props.onChange(e);
		}
	};

	useEffect(() => {
		if (props.isIndeterminate !== null && toggleRef.current) {
			toggleRef.current.indeterminate = props.isIndeterminate as boolean;
		}
	}, [props.isIndeterminate]);

	return (
		<div
			className={`${props.type} ${props.size} ${props.extraClass} ${
				props.hideCheck && props.type !== ToggleType.Switch ? 'hide-check' : ''
			}`}
		>
			<label htmlFor={toggleId}>
				<input
					ref={toggleRef}
					type={props.type === ToggleType.Radio ? 'radio' : 'checkbox'}
					id={toggleId}
					aria-invalid={props.invalid}
					defaultChecked={props.checked}
					disabled={props.disabled}
					checked={props.isChecked}
					onKeyDown={(e) => (props.onKeyDown ? props.onKeyDown(e) : undefined)}
					onChange={(e) => HandleCallBack(e)}
					value={props.type === ToggleType.Radio ? props.label : ''}
				/>
				<span className={'check'}>
					{props.hideLabel ? '' : <span dangerouslySetInnerHTML={{ __html: props.label }} />}
				</span>
			</label>

			{!props.hideValidation && <ValidationError value={props.validationMessage} />}
		</div>
	);
};
